import {
    getAddToCalendarLink,
    getEnterTheWebinarLink,
    useAnimIn,
} from "./../utils";

function ThankYouWebinarReg({ email, thankYouMessage = "" }) {

    const enterTheWebinarLink = getEnterTheWebinarLink({ email });

    const title = thankYouMessage ? thankYouMessage : "Thank you for registering.";

    const ref = React.useRef();
    useAnimIn(ref, {delay: 0});

    React.useEffect(() => {
        const elRegTitle = document.querySelector('.webinar-reg-title');
        if( elRegTitle ){
            elRegTitle.style.display = "none";
        }
    }, []);

    return (
        <div ref={ref} style={{opacity: '0'}} id="thank-you-webinar-app">
            <div id="webinar-thank-you-msg" className="d-flex flex-column justify-content-center" style={{minHeight: '25vh'}}>
                <h2 className=" h3 mb-0 text-center font-heading">{title}</h2>
                <p className="my-3 text-center">
                    You can enter the Webinar up to 30 minutes prior to the
                    start time.
                </p>

                <div className="d-flex flex-column align-items-center mb-4">
                    <a
                        href={enterTheWebinarLink}
                        target="_blank"
                        className="bg-aw-webinar text-decoration-none rounded-pill px-3 py-2 text-uppercase text-white font-weight-bold text-small"
                    >
                        Enter the Webinar
                    </a>
                    
				</div>
			</div>
		</div>
	);
}

export default ThankYouWebinarReg;
